import styled from 'styled-components';

// Container
export const AboutContainer = styled.div.attrs(() => ({
  className: 'bg-gray-100 py-12 px-6',
}))``;

// Heading
export const AboutHeading = styled.h1.attrs(() => ({
  className: 'text-4xl font-bold text-center text-[#003366] mb-6',
}))``;

// Profile Section
export const AboutProfile = styled.div.attrs(() => ({
  className: 'text-center mb-8',
}))``;

export const AboutProfileImage = styled.img.attrs(() => ({
  className: 'w-48 h-48 object-cover rounded-full mx-auto border-4 border-[#FF6600]',
  alt: "Michael's Profile",
}))``;

// Text Section
export const AboutTextSection = styled.div.attrs(() => ({
  className: 'max-w-3xl mx-auto text-gray-700 text-lg leading-relaxed space-y-6',
}))``;
